"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _ModalLayout = require("./parts/ModalLayout");
var _Features = require("./parts/Features");
var _MortgageLegalInfo = require("./parts/MortgageLegalInfo");
var _NewbuildingsList = require("./parts/NewbuildingsList");
var _FullCreditPrice = require("./parts/FullCreditPrice");
var _BanksList = require("./parts/BanksList");
var _CianMortgageBank = require("./parts/CianMortgageBank");
var _PurchaseTerms = require("./parts/PurchaseTerms");
var _FeaturesLayout = require("./parts/FeaturesLayout");
var _LinkedPromos = require("../PurchaseTermsModal/parts/LinkedPromos");
var _PromoHeader = require("./parts/PromoHeader");
var _CreditTerms = require("./parts/CreditTerms");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Content = props => {
  const {
    promo,
    mortgageLegalInfo,
    mortgagePartnerLink,
    onCianMortgageClick,
    fullCreditPriceModalText,
    listingUrl,
    newbuildingCountText,
    onNewbuildingListingLinkClick,
    onNewbuildingLinkClick,
    size,
    onCreditFullPriceClick
  } = props;
  return /*#__PURE__*/React.createElement(_ModalLayout.ModalLayout, null, /*#__PURE__*/React.createElement(_PromoHeader.PromoHeader, {
    authorName: promo.authorName,
    promoName: promo.name,
    authorLogo: promo.authorLogo,
    labels: promo.labels
  }), /*#__PURE__*/React.createElement(_PurchaseTerms.PurchaseTerms, {
    terms: promo.availablePurchaseTerms
  }), /*#__PURE__*/React.createElement(_FeaturesLayout.FeaturesLayout, null, /*#__PURE__*/React.createElement(_Features.Features, {
    features: promo.features,
    fullCreditPriceTooltip: fullCreditPriceModalText,
    size: size,
    onCreditFullPriceClick: onCreditFullPriceClick,
    isBankMortgage: Boolean(promo.isBankMortgage)
  }), /*#__PURE__*/React.createElement(_FullCreditPrice.FullCreditPrice, {
    title: promo.fullCreditPriceTitle,
    tooltip: fullCreditPriceModalText,
    trackClickHandler: onCreditFullPriceClick
  })), /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    whiteSpace: "pre-wrap"
  }, promo.description), /*#__PURE__*/React.createElement(_CreditTerms.CreditTerms, {
    terms: promo.creditTerms
  }), /*#__PURE__*/React.createElement(_MortgageLegalInfo.MortgageLegalInfo, {
    info: mortgageLegalInfo
  }), /*#__PURE__*/React.createElement(_CianMortgageBank.CianMortgageBank, {
    bank: promo.cianMortgageBank,
    mortgagePartnerLink: mortgagePartnerLink,
    promoType: promo.type,
    onMortgageClick: onCianMortgageClick
  }), /*#__PURE__*/React.createElement(_BanksList.BanksList, {
    banks: promo.banks
  }), /*#__PURE__*/React.createElement(_NewbuildingsList.NewbuildingsList, {
    newbuildings: props.promo.availableJks,
    listingUrl: listingUrl,
    newbuildingCountText: newbuildingCountText,
    onListingLinkClick: onNewbuildingListingLinkClick,
    onNewbuildingClick: onNewbuildingLinkClick
  }), /*#__PURE__*/React.createElement(_LinkedPromos.LinkedPromos, {
    promos: promo.linkedPromos
  }));
};
exports.Content = Content;